(() => {
  const blockSelector = 'div.shopify-block.shopify-app-block[id*="subscriptions_app_block"]';
  const addButtonSelector = 'button[name="add"][data-testid="standalone-add-to-cart"]';
  const cartLinesUpdateEvent = 'shopify:cart:lines-update';
  const controllers = new WeakMap();
  let subscriptionCheckoutIntent = false;
  let subscriptionCheckoutTimer;

  function shouldPrefillSubscription() {
    const value = new URLSearchParams(window.location.search).get('purchase');
    return value?.toLowerCase() === 'subscription';
  }

  function planFrequencyLabel(radio) {
    const source = radio.getAttribute('aria-label') || radio.closest('label')?.innerText || 'Delivery frequency';
    return source.split(',')[0].replace(/^Deliver\s+/i, '').trim();
  }

  function recommendedPlan(radios) {
    return radios.find((radio) => /every month/i.test(radio.getAttribute('aria-label') || '')) || radios[0];
  }

  function visibleSection(appBlock) {
    return [...appBlock.querySelectorAll('.shopify_subscriptions_app_block')]
      .find((section) => !section.classList.contains('shopify_subscriptions_app_block--hidden'));
  }

  function setDirectButtonText(button, label) {
    if (!(button instanceof HTMLButtonElement)) return;
    const textNode = [...button.childNodes].find((node) => node.nodeType === Node.TEXT_NODE && node.textContent.trim());
    if (textNode) textNode.textContent = `\n${label}\n    `;
  }

  function updateAddButton(subscriptionSelected) {
    const button = document.querySelector(addButtonSelector);
    if (!(button instanceof HTMLButtonElement)) return;
    button.dataset.furseraOneTimeLabel ||= 'Add to cart';
    setDirectButtonText(button, subscriptionSelected ? 'Start subscription' : button.dataset.furseraOneTimeLabel);
  }

  function setState(controller, open) {
    const { section, oneTimeGroup, subscriptionGroup, title, details, select, radios } = controller;
    const selectedRadio = radios.find((radio) => radio.checked);
    const subscriptionSelected = Boolean(selectedRadio);

    section.classList.toggle('fursera-subscription-open', open && subscriptionSelected);
    oneTimeGroup.classList.toggle('fursera-choice-selected', !subscriptionSelected);
    subscriptionGroup.classList.toggle('fursera-choice-selected', subscriptionSelected);
    title.setAttribute('aria-expanded', String(open && subscriptionSelected));
    title.setAttribute('aria-checked', String(subscriptionSelected));
    details.hidden = !(open && subscriptionSelected);

    if (selectedRadio) select.value = selectedRadio.dataset.sellingPlanId || '';
    updateAddButton(subscriptionSelected);
  }

  function selectPlan(controller, radio) {
    if (!radio) return;
    refreshRecommendation(controller);
    radio.click();
    controller.select.value = radio.dataset.sellingPlanId || '';
  }

  function refreshRecommendation(controller) {
    const recommended = recommendedPlan(controller.radios);
    for (const option of controller.select.options) {
      const radio = controller.radios.find((candidate) => candidate.dataset.sellingPlanId === option.value);
      option.textContent = `${planFrequencyLabel(radio)}${radio === recommended ? ' (Recommended)' : ''}`;
    }

    if (!controller.radios.some((radio) => radio.checked)) {
      controller.select.value = recommended?.dataset.sellingPlanId || '';
      controller.summaryPrice.textContent = recommended?.dataset.variantPrice || '';
    }
  }

  function enhanceSection(appBlock, section, sectionIndex) {
    if (section.dataset.furseraPurchaseOptions === 'amazon-v1') return;

    const planCard = section.querySelector('.plan_card');
    const groups = planCard ? [...planCard.children].filter((child) => child.classList.contains('subscription_group')) : [];
    const oneTimeGroup = groups.find((group) => group.querySelector('[data-radio-type="one_time_purchase"]'));
    const subscriptionGroup = groups.find((group) => group.querySelector('[data-radio-type="selling_plan"]'));
    const oneTimeRadio = oneTimeGroup?.querySelector('[data-radio-type="one_time_purchase"]');
    const title = subscriptionGroup?.querySelector(':scope > .title_and_price_wrapper');
    const list = subscriptionGroup?.querySelector(':scope > .group_list');
    const radios = list ? [...list.querySelectorAll('[data-radio-type="selling_plan"]')] : [];
    if (!oneTimeGroup || !subscriptionGroup || !oneTimeRadio || !title || !list || !radios.length) return;

    const detailsId = `fursera-subscription-details-${appBlock.id || 'product'}-${sectionIndex}`;
    const dot = document.createElement('span');
    dot.className = 'fursera-choice-dot';
    dot.setAttribute('aria-hidden', 'true');

    const headerCopy = document.createElement('span');
    headerCopy.className = 'fursera-subscription-header-copy';
    const titleRow = document.createElement('span');
    titleRow.className = 'fursera-subscription-title-row';
    const titleText = document.createElement('span');
    titleText.className = 'fursera-subscription-title';
    titleText.textContent = 'Subscribe & Save';
    const badge = document.createElement('span');
    badge.className = 'fursera-subscription-save-badge';
    badge.textContent = 'Save 15%';
    const benefit = document.createElement('span');
    benefit.className = 'fursera-subscription-benefit';
    benefit.textContent = 'Automatic deliveries · skip or cancel anytime';
    titleRow.append(titleText, badge);
    headerCopy.append(titleRow, benefit);

    const summaryPrice = document.createElement('span');
    summaryPrice.className = 'fursera-subscription-summary-price';
    title.replaceChildren(dot, headerCopy, summaryPrice);

    const details = document.createElement('div');
    details.id = detailsId;
    details.className = 'fursera-subscription-details';
    const savingCopy = document.createElement('p');
    savingCopy.className = 'fursera-subscription-saving-copy';
    savingCopy.textContent = 'Save 15% on every delivery';
    const frequencyLabel = document.createElement('label');
    frequencyLabel.className = 'fursera-frequency-label';
    frequencyLabel.append(document.createTextNode('Deliver every:'));
    const select = document.createElement('select');
    select.className = 'fursera-frequency-select';
    for (const radio of radios) {
      const option = document.createElement('option');
      option.value = radio.dataset.sellingPlanId || '';
      option.textContent = planFrequencyLabel(radio);
      select.append(option);
    }
    frequencyLabel.append(select);
    const note = document.createElement('p');
    note.className = 'fursera-subscription-note';
    note.textContent = 'Monthly delivery is selected by default. Change the frequency anytime, or skip or cancel future deliveries.';
    details.append(savingCopy, frequencyLabel, note);
    subscriptionGroup.append(details);

    list.hidden = true;
    list.setAttribute('aria-hidden', 'true');
    subscriptionGroup.classList.add('fursera-subscription-option');
    title.classList.add('fursera-subscription-toggle');
    title.setAttribute('role', 'radio');
    title.setAttribute('tabindex', '0');
    title.setAttribute('aria-controls', detailsId);

    const controller = { section, oneTimeGroup, subscriptionGroup, title, radios, details, select, summaryPrice };
    controllers.set(section, controller);
    refreshRecommendation(controller);

    const handleSubscriptionCard = () => {
      const subscriptionSelected = radios.some((radio) => radio.checked);
      const isOpen = section.classList.contains('fursera-subscription-open');
      if (subscriptionSelected && isOpen) {
        setState(controller, false);
        return;
      }
      if (subscriptionSelected) {
        setState(controller, true);
        return;
      }
      selectPlan(controller, recommendedPlan(radios));
    };
    title.addEventListener('click', handleSubscriptionCard);
    title.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      handleSubscriptionCard();
    });
    select.addEventListener('change', () => {
      selectPlan(controller, radios.find((radio) => radio.dataset.sellingPlanId === select.value));
    });
    section.addEventListener('change', (event) => {
      const radioType = event.target?.dataset?.radioType;
      if (radioType === 'selling_plan') {
        summaryPrice.textContent = event.target.dataset.variantPrice || '';
        setState(controller, true);
      }
      if (radioType === 'one_time_purchase') setState(controller, false);
    });

    let selectedRadio = radios.find((radio) => radio.checked);
    if (!selectedRadio && shouldPrefillSubscription()) {
      selectedRadio = recommendedPlan(radios);
      selectPlan(controller, selectedRadio);
    }

    summaryPrice.textContent = (selectedRadio || recommendedPlan(radios))?.dataset.variantPrice || '';
    setState(controller, Boolean(selectedRadio));
    section.dataset.furseraPurchaseOptions = 'amazon-v1';
  }

  function enhance(root = document) {
    const appBlocks = [];
    if (root.matches?.(blockSelector)) appBlocks.push(root);
    appBlocks.push(...root.querySelectorAll(blockSelector));

    new Set(appBlocks).forEach((appBlock) => {
      const sections = [...appBlock.querySelectorAll('.shopify_subscriptions_app_block')];
      const section = sections.find((candidate) => !candidate.classList.contains('shopify_subscriptions_app_block--hidden'));
      if (section) enhanceSection(appBlock, section, sections.indexOf(section));
    });
  }

  function refreshVisibleControllers() {
    document.querySelectorAll(blockSelector).forEach((appBlock) => {
      const sections = [...appBlock.querySelectorAll('.shopify_subscriptions_app_block')];
      const section = visibleSection(appBlock);
      if (section && !controllers.has(section)) enhanceSection(appBlock, section, sections.indexOf(section));
      const controller = section ? controllers.get(section) : null;
      if (!controller) return;
      refreshRecommendation(controller);
      setState(controller, controller.radios.some((radio) => radio.checked));
    });
  }

  function clearSubscriptionCheckoutIntent() {
    subscriptionCheckoutIntent = false;
    window.clearTimeout(subscriptionCheckoutTimer);
  }

  function captureSubscriptionCheckoutIntent(event) {
    const button = event.target?.closest?.(addButtonSelector);
    const form = button?.closest('form');
    const sellingPlan = form?.querySelector('input[name="selling_plan"]');
    if (!(sellingPlan instanceof HTMLInputElement) || !sellingPlan.value) return;

    subscriptionCheckoutIntent = true;
    window.clearTimeout(subscriptionCheckoutTimer);
    subscriptionCheckoutTimer = window.setTimeout(clearSubscriptionCheckoutIntent, 15000);
  }

  function redirectSubscriptionToCheckout(event) {
    if (!subscriptionCheckoutIntent || event.action !== 'add' || event.context !== 'product') return;
    clearSubscriptionCheckoutIntent();

    event.promise
      ?.then(({ detail }) => {
        if (detail?.didError) return;
        window.location.assign('/checkout');
      })
      .catch(() => {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => enhance());
  } else {
    enhance();
  }

  document.addEventListener('shopify:section:load', (event) => enhance(event.target));
  document.addEventListener('click', captureSubscriptionCheckoutIntent, true);
  document.addEventListener(cartLinesUpdateEvent, redirectSubscriptionToCheckout);
  document.addEventListener('shopify:product:select', (event) => {
    if (!event.target?.closest?.('variant-picker')) return;
    window.requestAnimationFrame(refreshVisibleControllers);
    event.promise?.then(() => window.requestAnimationFrame(refreshVisibleControllers)).catch(() => {});
  });
  document.addEventListener('change', (event) => {
    if (!event.target?.matches?.('.variant-picker input[type="radio"]')) return;
    window.requestAnimationFrame(refreshVisibleControllers);
    window.setTimeout(refreshVisibleControllers, 500);
  });
})();
